import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {EApplicationParametersActions, SetDatasourcePartyId} from "../../actions/application-parameters/application-parameters.actions";
import {concatMapTo, mapTo, tap, withLatestFrom} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {InitMDMStore, LoadTypes} from "../../actions/mdm/mdm.actions";

@Injectable()
export class AppParametersEffects {
  datasourcePartyId$ =  createEffect(() => this._actions$.pipe(
    ofType<SetDatasourcePartyId>(EApplicationParametersActions.SetDatasourcePartyId),
    withLatestFrom(this._store$),
    /*tap(
      ([action,storeState]) =>{
        //this._store$.dispatch( new TranslateResources(storeState.language.currentLanguage));
        //this._store$.dispatch( new LoadSuppliers())
        console.log('SetDatasourcePartyId effect');
      }
    )
    */
   concatMapTo( [
     //new LoadNomenclature(),
     //new LoadOrganisation(),
     //new LoadStores(),
     //new LoadOsaTypes(),

     //new LoadSuppliers(),
     //new LoadFinDepartments()
      new InitMDMStore()
      //new LoadTypes()



   ])
  ));


  constructor(
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}
